module.exports = __webpack_public_path__ + "img/media-10.387ba6c8.png";